import React from 'react';
import { QueryClient, QueryClientProvider, QueryObserverOptions } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import GradingHooks from './GradingHooks';
import CardContainer from './CardContainer';
import HeaderWithFilters from './HeaderWithFilters';

interface GradingProps {
  programId: number;
  submissionId: number;
  userId: number;
  userType: string;
}

const Grading = ({ programId, submissionId, userId, userType } : GradingProps) => {
  GradingHooks({ programId, submissionId, userId, userType });
  const { isLoading, assignment } = useGradingStore();

  if (isLoading) return <span>Loading...</span>;

  return (
    <>
      <div className="tw-py-4">
        <h1>{assignment.assignment_details.type} Results by Student</h1>
      </div>
      <HeaderWithFilters />
      <CardContainer />
    </>
  );
};

const GradingWrapper = ({ programId, submissionId, userId, userType } : GradingProps) => {
  const BASE_OPTIONS: QueryObserverOptions = {
    networkMode: 'always',
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: 0,
  };

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { ...BASE_OPTIONS },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <Grading
        programId={programId}
        submissionId={submissionId}
        userId={userId}
        userType={userType}
      />
    </QueryClientProvider>
  );
};

export default GradingWrapper;
